
    document.addEventListener('DOMContentLoaded',function() {
         countDown();
          function addZero(i) {
              return i < 10 ? "0" + i: i + "";
          }
          function countDown() {
              var starttime = new Date();
              var endtime = new Date("2023/12/14,07:00:00");
              var lefttime = parseInt((endtime.getTime() - starttime.getTime()) / 1000);
              var d = parseInt(lefttime / (24*60*60))
              var h = parseInt(lefttime / (60 * 60) % 24);
              var m = parseInt(lefttime / 60 % 60);
              var s = parseInt(lefttime % 60);
              d = addZero(d)
              h = addZero(h);
              m = addZero(m);
              s = addZero(s);
              document.querySelector("#collection_time").innerHTML = `<div style="display: flex;font-size: 12px;align-items: center;"><img style="width:25px;margin-right: 5px;" src="https://cdn.shopify.com/s/files/1/0420/8682/6138/files/Group_39.png?v=1681977109" width="44" height="51" alt="flash_sale" />Endet in: 
                                                                <div style="margin-left: 5px;"><span style="display: inline-block;width: 32px;height: 28px; line-height: 28px; background: rgb(52,52,50); color: #fdd000;text-align: center; margin: 0 4px;border-radius: 4px;">${d}</span><span style="">D</span></div>
                                                                <div><span style="display: inline-block;width: 32px;height: 28px; line-height: 28px; background: rgb(52,52,50); color: #fdd000;text-align: center;margin: 0 4px;border-radius: 4px;">${h}</span><span style="">H</span></div>
                                                                <div><span style="display: inline-block;width: 32px;height: 28px;line-height: 28px; background: rgb(52,52,50); color: #fdd000;text-align: center; margin: 0 4px;border-radius: 4px;">${m}</span><span style="">M</span></div>
                                                                <div><span style="display: inline-block;width: 32px;height: 28px;line-height: 28px; background: rgb(52,52,50); color: #fdd000;text-align: center; margin: 0 4px;border-radius: 4px;">${s}</span><span style="">S</span></div></div>`;
              if (lefttime <= 0) {
                  document.querySelector("#collection_time").style.display = "none";
                  return;
              }
              setTimeout(countDown, 1000);
            }
    })

